import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"px-3 bg-gray-200",staticStyle:{"padding":"1px 0"}},[_c(VIcon,{attrs:{"size":"16"}},[_vm._v("mdi-map-marker")]),_c('span',{staticClass:"ml-1 font-13 font-weight-medium"},[_vm._v("Cobertura do Estoque de Segurança por curvas")])],1),_c(_setup.Tabela,{staticClass:"px-1 mt-1"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }